import axios from 'axios/dist/axios'

class Api {
  constructor () {
    this.axios = axios.create({
      baseURL: '/api/'
    })

    this.axiosDrupal = axios.create({
      baseURL: '/'
    })
  }

  home () {
    return this.axios.get('home')
  }

  menu () {
    return this.axios.get('menu')
  }

  page (url) {
    return this.axios.get('page/', {
      params: {
        page: url
      }
    })
  }

  drupal (url) {
    return this.axiosDrupal.get(url, {
      params: {
        _wrapper_format: 'drupal_ajax'
      }
    })
  }
}

export default new Api()
